import { type ReactNode, useMemo } from 'react';

import { type MessageDescriptor, useIntl } from 'react-intl-next';

import type { FallbackUrl, GlobalShortcutLinkItem } from '../../types';

export function useAppGlobalShortcutLinkItem(
	icon: ReactNode,
	label: MessageDescriptor,
	fallbackUrl: FallbackUrl,
	options?: Pick<
		GlobalShortcutLinkItem,
		'labelElem' | 'apsKey' | 'ref' | 'analyticsName' | 'menuItemId'
	>,
): GlobalShortcutLinkItem {
	const { labelElem, apsKey, ref, analyticsName, menuItemId } = options ?? {};
	const { formatMessage } = useIntl();
	const labelText = formatMessage(label);

	return useMemo(
		() => ({
			type: 'link',
			icon,
			label: labelText,
			labelElem,
			apsKey,
			fallbackUrl,
			ref,
			analyticsName,
			...(menuItemId ? { menuItemId } : {}),
		}),
		// Intentionally remove the ref, as it isn't needed by useMemo, and can cause extra rendering.
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[analyticsName, apsKey, fallbackUrl, icon, labelElem, labelText, menuItemId],
	);
}
